import { type ReactNode } from 'react';

// Blurred placeholder card. No backend data yet — every slot renders
// the same generic silhouette. `content-visibility: auto` lets the
// browser skip layout/paint for offscreen cards, keeping the 3333
// list responsive without a virtualization library.
const SLOT_STYLE = {
  contentVisibility: 'auto' as const,
  containIntrinsicSize: '320px 240px',
};

function Silhouette(): ReactNode {
  return (
    <div className="absolute inset-0 overflow-hidden">
      <div
        aria-hidden
        className="absolute -inset-x-6 -top-6 h-[70%] rounded-full bg-gradient-to-br from-brand-red/15 via-surface-elevated to-brand-coral/10 blur-2xl"
      />
      <div
        aria-hidden
        className="absolute inset-x-6 bottom-6 h-[40%] rounded-[50%] bg-gradient-to-t from-surface to-transparent blur-xl"
      />
    </div>
  );
}

type SlotProps = { n: number; idPrefix?: string };

export function FounderSlot({ n, idPrefix = 'founder' }: SlotProps): ReactNode {
  return (
    <article
      id={`${idPrefix}-${n}`}
      style={SLOT_STYLE}
      className="relative aspect-[3/4] w-full snap-start overflow-hidden rounded-xl bg-gradient-to-br from-surface to-surface-elevated ring-1 ring-white/[0.04]"
    >
      <Silhouette />
      <div className="absolute inset-0 flex items-end justify-between p-md">
        <span className="font-display text-2xl font-bold tabular-nums text-white/90 drop-shadow sm:text-3xl">
          #{n}
        </span>
        <span className="text-[10px] uppercase tracking-wider text-text-tertiary/80">
          Oculto
        </span>
      </div>
    </article>
  );
}
